import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Provider } from "jotai";
import HomePage from "./pages/HomePage.js";
import AppPage from "./pages/AppPage.js";
import WelcomePage from "./pages/WelcomePage.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./styles/App.css";
import "./fonts/Nunito-Variable.woff2";
import "./fonts/Nunito-Italic.woff2";
import "./fonts/Bubbl-ExtraBold.woff2";

function App() {
  return (
    <Provider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/reset_password" element={<HomePage />} />
            <Route path="/app" element={<AppPage />} />
            <Route path="/welcome" element={<WelcomePage />} />
            {/* Redirect any unknown routes to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>

          <ToastContainer
            position="top-center"
            autoClose={10000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </div>
      </Router>
    </Provider>
  );
}

export default App;
